////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const logExtranet = {
	[ActionsTypes.POST_LOG_EXTRANET]: (state) =>
		update(state, {
			logExtranet: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.POST_LOG_EXTRANET_SUCCESS]: (state, payload) => {
		let itemsConf = cloneDeep(payload.data.headerContent.contentPagined.content)
		itemsConf.forEach((elem) => (elem['selected'] = false))
		let paginedData = payload.data.headerContent.contentPagined

		return update(state, {
			logExtranet: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: itemsConf,
				},
				paging: {
					$set: paginedData,
				},
				header: {
					$set: payload.data.headerParam.filters,
				},
			},
		})
	},
	[ActionsTypes.POST_LOG_EXTRANET_FAILURE]: (state, _payload) =>
		update(state, {
			logExtranet: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: ' payload.error,',
				},
			},
		}),
	[ActionsTypes.RESET_LOG_EXTRANET]: (state) =>
		update(state, {
			logExtranet: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: [],
				},
				header: {
					$set: {},
				},
				paging: {
					$set: {},
				},
			},
		}),
}

export default logExtranet
